import { InputGroup, Select, Stack, Text, Textarea } from '@chakra-ui/react';
import { useState } from 'react';

const MANUAL_REASON = 'Other: details required';

export const TradeReasonSelector = ({
    selectedReason,
    setSelectedReason,
    manualReason,
    setManualReason,
}: {
    selectedReason?: string;
    setSelectedReason: (newReason: string) => void;
    manualReason?: string;
    setManualReason: (newReason: string) => void;
}) => {
    return (
        <Stack>
            <Text fontWeight="medium">
                Reason
                <Text as="span" color="red.400">
                    *
                </Text>
            </Text>
            <Select size="sm" value={selectedReason} onChange={(ev) => setSelectedReason(ev.target.value)}>
                <option></option>
                <option>Cash Flow Trade</option>
                <option>Client Directed Trade</option>
                <option>Onboarding Trades</option>
                <option>{MANUAL_REASON}</option>
                <option>Rebalance</option>
                <option>Technical Issue</option>
                <option>Transition</option>
            </Select>
            {selectedReason === MANUAL_REASON && (
                <InputGroup size="sm">
                    <Textarea
                        placeholder="Details"
                        resize="none"
                        value={manualReason}
                        onChange={(ev) => setManualReason(ev.target.value)}
                    />
                </InputGroup>
            )}
        </Stack>
    );
};

export const useTradeReasonState = () => {
    const [selectedReason, setSelectedReason] = useState('');
    const [manualReason, setManualReason] = useState('');

    return {
        setSelectedReason,
        setManualReason,
        selectedReason,
        manualReason,
        reason: selectedReason === MANUAL_REASON ? manualReason : selectedReason,
    };
};
